module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Tucson-Playful.12633405.jpeg";